<template>
  <div id="app">
    <router-view></router-view>
   <!-- <keep-alive include="billsCP">
     <router-view></router-view>
   </keep-alive> -->

  </div>
</template>

<script>
import {setCookie,getCookie} from '@/utils/support.js';
import { mapActions,mapState } from 'vuex'

export default {
  // name: 'App'
  // computed: {
  //   ...mapGetters([
  //     'catchList',
  //   ])
  // },
  computed: {
    ...mapState({
      orderTypeList: state => state.orderSelect.orderTypeList,
    }),
  },
  mounted() {
    // console.log(555,this.orderTypeList,this.orderTypeList.length)
    if (getCookie("crmToken")&&!this.orderTypeList||getCookie("crmToken")&&this.orderTypeList.length<1) {
      this.getDocumentEnumeration()
    }
  },
  methods:{
      ...mapActions([
        'getDocumentEnumeration',
      ]),
    // hide(e){
    //   if (!e.target.closest('.cpWrapper')) {
    //     // console.log('showList',this.showList)
    //     if (this.showList) {
    //       this.$store.dispatch('ShowCheckList')
    //     } else{
    //       return
    //     }
    //   }
    // },

  }
}
</script>

<style>
#app {
  font-family: Microsoft YaHei;
  color: #303133;
  font-size: 14px;
  /* background-color: #ECF5FF; */
}

</style>



// WEBPACK FOOTER //
// src/App.vue